/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import LangContext from "../../contextProvider/LangContext";
import moment from "moment";
import PageToolbar from "../../components/PageToolbar";
import { Button, Card, Col, Form } from "antd";
import { Row } from "antd/es/grid";
import GenericModal from "../../components/GenericModal";
import DateTimePicker from "../../components/DateTimePicker";
import TableIDs from "../../data/TableIDs";
import GenericSelector from "../../components/GenericSelector";

const curdate = moment().format("YYYY-MM-DD")

class CrmDashboard extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _filterType: 1,
            _startDate: curdate,
            _endDate: curdate,
            _user: "" + props.user.userId,

            modalDateSelect: null,
            modalUserSelect: null,


        };

        this.id = "CRM_DASHBOARD";

        this.api = {
            get: "get_crm_dashboard",
        }

        if (props.data[this.id] === undefined) props.data[this.id] = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidMount() {
        this.setFilter()
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(20995);
    }

    setFilter = () => {
        this.props.dataActions.genericDataSetFilter(
            this.id, this.props.user.companyCode, this.props.user.token, {
            _startDate: this.state._startDate,
            _endDate: this.state._endDate,
            _user: this.state._user,
            // just of ui-pagination update
            page: 1,
            recordsPerPage: 3,
            sortType: 1,
            sortColumn: 1,
        }, this.api.get)
    }

    getButton = (text, type) => {

        return (<Button
            style={{ marginTop: 5, marginLeft: 5 }}
            type={this.state._filterType == type ? "primary" : ""}
            onClick={() => {
                let _startDate = curdate
                let _endDate = curdate
                if (type == 5) {
                    this.setState({ modalDateSelect: { _startDate, _endDate } })
                } else {
                    if (type == 2) {
                        _startDate = moment().add(-30, "day").format("YYYY-MM-DD")
                    } else if (type == 3) {
                        _startDate = moment().format("YYYY-MM-01")
                    } else if (type == 4) {
                        _startDate = moment().add(-1, "month").format("YYYY-MM-01")
                        _endDate = moment(moment().format("YYYY-MM-01")).add(-1, "day").format("YYYY-MM-DD")
                    }
                    this.setState({ _filterType: type, _startDate, _endDate }, this.setFilter)
                }
            }}
        >{text}</Button>)
    }

    getDateFilter = (field) => {
        return (<DateTimePicker
            format="DD/MM/YYYY"
            value={this.state.modalDateSelect ? this.state.modalDateSelect[field] : null}
            onChange={e => { this.setState({ modalDateSelect: { ...this.state.modalDateSelect, [field]: e } }) }}
        />)
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl", // dir: "ltr"
            padding: "2% 2% 2% 2%",
        };

        const { data } = this.props.data[this.id]

        let actionButtons = [{
            buttonType: 'refresh',
            buttonFunction: this.setFilter
        }]

        if (this.props.data[TableIDs.pseudoSelectorUIcomponentsModules].dataset?.find(f => f.code === '541')) {
            actionButtons.push({
                buttonType: 'filter',
                buttonFunction: () => { this.setState({ modalUserSelect: this.state._user }) },
                tooltip: gt(21675)
            })
        }

        

        return (<div style={divStyle}>
            <PageToolbar
                title={gt(20996)}
                actionButtons={actionButtons}
                genericActionButtons={[
                    this.getButton(gt(20997), 1),
                    this.getButton(gt(20998), 2),
                    this.getButton(gt(20999), 3),
                    this.getButton(gt(21000), 4),
                    this.getButton(gt(21001), 5),
                ]}
            />

            <div style={{ float: "left" }}>
                {moment(this.state._endDate).format("DD/MM/YYYY")}  -  {moment(this.state._startDate).format("DD/MM/YYYY")}
            </div>
            {data.map(x => {
                const [type, count, filter1, filter2, avg] = x.split("\f")
                let avgM = avg ? parseInt(avg) % 60 : 0
                let avgH = avg ? parseInt(avg / 60) % 24 : 0
                let avgD = avg ? parseInt(avg / 24 / 60) : 0

                return (<Card
                    style={{ width: 350, display: "inline-block", margin: 10 }}
                    title={gt(type == '1' ? 21002 : type == '2' ? 21003 : type == '3' ? 21004 : '')}>
                    <p style={{ fontSize: 50 }}>{count}</p>
                    <Row>
                        <Col span={10}><h3>{gt(type == '1' ? 21005 : 21008)}</h3></Col>
                        <Col span={7}><h3>{filter1}</h3></Col>
                        <Col span={7}><h3>{filter1 > 0 ? Math.round((filter1 / count) * 100) : 0}{'%'}</h3></Col>
                    </Row>
                    <Row>
                        <Col span={10}><h3>{gt(type == '1' ? 21006 : 21009)}</h3></Col>
                        <Col span={7}><h3>{filter2}</h3></Col>
                        <Col span={7}><h3>{filter2 > 0 ? Math.round((filter2 / count) * 100) : 0}{'%'}</h3></Col>
                    </Row>
                    <Row>
                        <Col span={10}><h3>{gt(21007)}</h3></Col>
                        <Col span={14}><h3>{avgD ? `${avgD} ${gt(21010)} + ` : ""}{avgH < 10 ? '0' : ''}{avgH}:{avgM < 10 ? '0' : ''}{avgM} {gt(21011)}</h3></Col>
                    </Row>

                </Card>)
            })}
            <GenericModal
                visible={this.state.modalDateSelect != null}
                onCancel={() => { this.setState({ modalDateSelect: null }) }}
                width={300}
                title={gt(21012)}
                footer={[
                    <Button onClick={() => { this.setState({ modalDateSelect: null }) }}>{gt(21016)}</Button>,
                    <Button type="primary" onClick={() => {
                        const { _startDate, _endDate } = this.state.modalDateSelect
                        this.setState({ modalDateSelect: null, _startDate, _endDate, _filterType: 5 }, this.setFilter)
                    }}>{gt(21015)}</Button>
                ]}
            >
                <Form.Item label={gt(21013)}>{this.getDateFilter("_startDate")}</Form.Item>
                <Form.Item label={gt(21014)}>{this.getDateFilter("_endDate")}</Form.Item>
            </GenericModal>

            <GenericModal
                visible={this.state.modalUserSelect != null}
                onCancel={() => { this.setState({ modalUserSelect: null }) }}
                width={400}
                title={gt(21676)}
                footer={[
                    <Button onClick={() => { this.setState({ modalUserSelect: null }) }}>{gt(21016)}</Button>,
                    <Button type="primary" onClick={() => {
                        const  _user  = this.state.modalUserSelect
                        this.setState({ modalUserSelect: null, _user }, this.setFilter)
                    }}>{gt(21678)}</Button>
                ]}
            >
                <Form.Item label={gt(21677)}>
                    <GenericSelector
                        {...this.props}
                        id={TableIDs.genericSelectorUsers}
                        api={"get_users_list"}
                        value={this.state.modalUserSelect}
                        onChange={e => { this.setState({ modalUserSelect: e }) }}
                    />
                </Form.Item>
            </GenericModal>
        </div>)
    }

}

export default CrmDashboard;